<template>
    <div class="form-consult" v-if="form != null" :class="{'open' : openFormConsult}">
        <div class="quality-form-title">
            <h2>{{form.form_consult_title}}</h2>
            <a href="#" @click.prevent="closeForm" class="close-form-link">
                <svg-icon icon-class="close" className="share-icon icon-close"/>
            </a>
        </div>
        <form class="form_call">
            <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                <div class="form-group form-text">
                    <label for="name">{{form.name_label}}</label>
                    <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone">
                    <label for="phone">{{form.phone_label}}</label>
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000" v-if="projectHost != 'kohota'"/>
                    <masked-input v-model="phone" mask="\+\998 (11) 111-11-11" placeholder="+998" class="form-control" name="phone" v-validate="{ required: true }" data-vv-delay="1000" v-if="projectHost == 'kohota'"/>
                </div>
                <VueRecaptcha
                    ref="recaptchaFormConsult"
                    @verify="onCaptchaVerified"
                    :sitekey="salesGcap_siteKey"
                    size="invisible"
                />
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.send_call_btn_desc}}</button>
                    <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email')">Заполните все поля</span>
                </div>
            </div>
            <div class="successMessage" v-if="!formVisible">
                <h3>Спасибо! Ваша заявка отправлена.</h3>
            </div>
        </form>
        <div class="to-many-requests-msg" v-if="toManySendingMsg">
            <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
            <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
            <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    import { VueRecaptcha } from 'vue-recaptcha';
    const dict = {
        custom: {
            name: {
                required: () => 'Введите ваше имя'
            },
            phone: {
                required: () => 'Введите ваш номер телефона'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'FormConsult',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                quest: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                projectHost: window.host,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            saleItem: 'loadSaleCardItem',
            form: 'loadForms',
            openFormConsult: 'loadOpenFormConsult',
            formData: 'loadFormConsultData',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('shablonformPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('shablonformPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'project' : this.saleItem.project_name.slug,
                    'name': this.name,
                    'phone': this.phone,
                    'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                };
                if (window.host == 'qazyna') {
                    data.project = this.saleItem.project_name.slug.charAt(0).toUpperCase() + this.saleItem.project_name.slug.slice(1);
                } 
                this.formVisible = false;
                // console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('shablonformPage_submissionCounter', submissionCounter);
                    localStorage.setItem('shablonformPage_lastSubmissionTime', currentMinutes);
                    dataLayer.push({'event' : 'form_sent'});
                    setTimeout(() => {
                        this.closeForm();
                    }, 1500);
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok')
                        this.$refs.recaptchaFormConsult.execute();
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            closeForm() {
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                this.phone = '';
                this.name = '';
                this.mail = '';
                setTimeout(() => {
                    this.formVisible = true;
                }, 1000);
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-consult.scss';
    @import '@/styles/respond/forms/form-consult-respond.scss';
</style>